import { CountryViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { OptionType } from '@foradevelopment/fora-ui';

import { countriesFallback } from '../../common/utils';

export const getCountriesOptions = (countries: CountryViewModel[]): OptionType[] => {
  if (countries?.length > 1) {
    return countries.map(country => {
      return {
        id: country.countryCode,
        name: country.countryName,
      };
    });
  }

  return countriesFallback;
};
